import React, { useContext, useState } from "react";
import axiosInstance from "../utils/Requests/axios";
import LanguageContext from "../utils/Contexts/LanguageContext";
import UserContext from "../utils/Contexts/UserContext";
import toast from "react-hot-toast";

function AddRemoveModal({ listsData, listItem }) {
  const { t } = useContext(LanguageContext);
  const { userData } = useContext(UserContext);
  const [selectedUuids, setSelectedUuids] = useState([]);

  const handleToggle = (uuid) => {
    setSelectedUuids((prevSelectedUuids) => {
      if (prevSelectedUuids.includes(uuid)) {
        return prevSelectedUuids.filter((id) => id !== uuid);
      } else {
        return [...prevSelectedUuids, uuid];
      }
    });
  };

  const handleSave = async () => {
    const promises = [];
    try {
      const url = `/users/${userData?.uuid}/preferences/domains/${listItem?.uuid}/lists`
      promises.push(axiosInstance.put(url, selectedUuids));
      await Promise.all(promises);
      closeModal(); 
    }
    catch (e) {
      toast.error(t(`There was an error adding domain to lists`));
    }
  };

  const closeModal = () => {
    const closeButton = document.querySelector('#modal-sm-add-remove-to-lists [data-bs-dismiss="modal"]');
    if (closeButton) {
      closeButton.click(); 
    } else {
      console.error('Close button not found.');
    }
  };

  return (
    <div
      id="modal-sm-add-remove-to-lists"
      className="modal fade"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenteredScrollableTitle"
      aria-hidden="true"
    >
      <div
        className="modal-dialog modal-sm modal-dialog-scrollable modal-dialog-centered"
        role="document"
      >
        <div className="modal-content">
          <div className="modal-header">
            <h3
              className="modal-title"
              id="exampleModalCenteredScrollableTitle"
            >
              {t("Add or Remove Domain from List")}
            </h3>
          </div>
          <div className="modal-body">
            {listsData.length &&
              listsData.map((item) => (
                <div className="form-check form-switch mb-4" key={item.uuid}>
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id={item.uuid}
                    // Use item.type or any other property if you need to control the checked state
                    onChange={() => handleToggle(item.uuid)}
                  />
                  <label className="form-check-label" htmlFor={item.uuid}>
                    {item.name}
                  </label>
                </div>
              ))}
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-white"
              data-bs-dismiss="modal"
            >
              {t("Close")}
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleSave}
            >
              {t("Save")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddRemoveModal;
